import { z } from 'zod';
import { NOTIFICATION_CHANNEL_IDS } from './communication-channel.registry.js';

export const CommunicationChannelParamSchema = z.object({
    channel: z.enum(NOTIFICATION_CHANNEL_IDS),
}).strict();

export const UpdateCommunicationChannelPolicySchema = z.object({
    isEnabled: z.boolean(),
}).strict();
